"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderList = orderList;
var _request = _interopRequireDefault(require("@/utils/request"));
// 超级补贴订单列表（数据源为成交态记录）
function orderList(params) {
  return (0, _request.default)({
    url: '/portal/system/supersubsidy/order',
    method: 'get',
    params: params
  });
}